import {
  buttonIconStyle,
  primaryButtonStyle,
  secondaryButtonStyle,
} from '../shared/styles/buttons.styles';
import { redesignTheme } from '../theme';

const { colors, spacing, breakpoints, sizes, fonts } = redesignTheme;
const contentMaxWidth = sizes.ebookContentMaxWidth;

/**
 * Page shell shared by the SeriousGame Play and View pages:
 * page background, actions row and the centered content card.
 * Spread into each page's makeStyles definition.
 */
export const seriousGameShellStyles = {
  page: {
    minHeight: 'calc(100vh - 80px)',
    width: '100%',
    boxSizing: 'border-box',
    backgroundColor: colors.background,
    padding: `${spacing.md}px clamp(${spacing.sm}px, 4vw, 120px) ${spacing.xl}px`,
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      padding: `${spacing.md}px 0 ${spacing.xl}px`,
    },
  },
  shell: {
    width: '100%',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.sm,
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: spacing.sm,
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      padding: `0 ${spacing.sm}px`,
    },
  },
  actionButton: {
    ...secondaryButtonStyle,
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      padding: '0 12px',
    },
  },
  actionIcon: {
    ...buttonIconStyle,
  },
  cardWrap: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
  },
  card: {
    width: '100%',
    maxWidth: contentMaxWidth,
    margin: '0 auto',
    boxSizing: 'border-box',
    borderRadius: 5,
    backgroundColor: '#fafafa',
    overflow: 'hidden',
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      maxWidth: '100%',
      width: '100%',
    },
  },
  cardInner: {
    display: 'flex',
    flexDirection: 'column',
    gap: 40,
    padding: 40,
    boxSizing: 'border-box',
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      gap: spacing.md,
      padding: spacing.sm,
    },
  },
  primaryButton: {
    ...primaryButtonStyle,
    width: '100%',
    minHeight: sizes.buttonHeight,
    height: sizes.buttonHeight,
    boxSizing: 'border-box',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '& p, & h1, & h2, & h3, & ul, & ol': {
      margin: 0,
    },
    '& span, & p': {
      lineHeight: 1.2,
    },
  },
  mediaImage: {
    display: 'block',
    width: '100%',
    height: 'auto',
    objectFit: 'contain',
  },
  loadingCenter: {
    minHeight: 420,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  unavailableTitle: {
    margin: 0,
    padding: 40,
    textAlign: 'center',
    fontFamily: fonts.opensansSemiBold,
    fontSize: 24,
    lineHeight: 1.3,
    color: colors.primary,
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      padding: spacing.sm,
      fontSize: 18,
    },
  },
} as const;
